import { Action, createReducer, on } from '@ngrx/store';
import { sessionActions } from '.';
import { SessionData } from 'src/app/user/session.service';

export interface SessionState {
  sessionData: SessionData | null;
  authenticated: boolean;
  loading: boolean;
  error: any;
}

const initialState: SessionState = {
  sessionData: null,
  authenticated: false,
  loading: false,
  error: null
};

const sessionReducer = createReducer<SessionState>(
  initialState,
  on(sessionActions.loginOk, (state, { username }) => ({
    ...state,
    sessionData: { ...state.sessionData, username } as SessionData
  })),
  on(sessionActions.fetchSession, (state) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(sessionActions.fetchSessionSuccess, (state, { sessionData }) => ({
    ...state,
    sessionData,
    authenticated: true,
    loading: false,
    error: null
  })),
  on(sessionActions.fetchSessionFailure, (state, { error }) => ({
    ...state,
    authenticated: false,
    loading: false,
    error
  }))
);

export function reducer(state: SessionState | undefined, action: Action) {
  return sessionReducer(state, action);
}
